namespace Nobox {
    export interface DivisionsRow {
        Id?: number;
        Name?: string;
        Spv?: string;
        SpvId?: number;
        AgentIds?: string;
        listAgent?: Nobox.Administration.UserRow[];
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
    }

    export namespace DivisionsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'NoBoxCRM.Divisions';
        export const lookupKey = 'NoBoxCRM.Divisions';

        export function getLookup(): Q.Lookup<DivisionsRow> {
            return Q.getLookup<DivisionsRow>('NoBoxCRM.Divisions');
        }
        export const deletePermission = 'Group:Delete';
        export const insertPermission = 'Group:Modify';
        export const readPermission = 'Group:View';
        export const updatePermission = 'Group:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Spv = "Spv",
            SpvId = "SpvId",
            AgentIds = "AgentIds",
            listAgent = "listAgent",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy"
        }
    }
}
